/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import L from "../Lang"
import BaseCom from "../BaseCom";
import Icon from "../Icon";

export class WorkorderCom extends BaseCom {
    priority = (level) => {
        if(!level)
            level = parseInt(this.state.item.priorityLevel);
        return <span className={level > 2 ? 'text-danger' : 'text-info'}>
            {level === 1 && <Icon icon="faAnglesDown" />}
            {level === 2 && <Icon icon="faAngleDown" />}
            {level === 3 && <Icon icon="faAngleUp" />}
            {level === 4 && <Icon icon="faAnglesUp" />}
        </span>;
    }
}